import $ from "jquery";
import { GuiBase } from "../GuiBase";
import { AppLog } from "../AppLog";

export class GuiOcr extends GuiBase {

    // Gesetzt, sobald die Analyse abgeschickt wurde — verhindert einen zweiten Lauf.
    private submitting = false;

    constructor() {
        super("Dokument");
    }

    protected override attachEvents() {
        $("#btnOcrAlleUncheck").on("click", (e) => this.clickUnCheck(e));
        $("#btnOcrAlleCheck").on("click", (e) => this.clickCheck(e));
        $("#chkOcrGewuenscht").on("change", () => this.updateWeiterButton());
        this.updateWeiterButton();

        // Doppel-Start auf DERSELBEN Seite verhindern + Fortschritt anzeigen: die Analyse
        // blockiert den Request u.U. > 1 Minute; ohne Sperre klickt der ungeduldige User erneut
        // und löst einen zweiten Natif-Lauf aus (DEVCLR-279). Am Form-Submit gesperrt (fängt
        // Klick UND Enter). Der "Browser-Zurück + neuer GUI-Thread"-Fall ist damit NICHT
        // abgedeckt (der Server-Lauf läuft entkoppelt weiter) — dafür DEVCLR-280.
        $("#detailForm").on("submit", (e) => this.onSubmitAnalyse(e));

        // Rückkehr aus dem bfcache (Browser-Zurück): der eingefrorene Sperr-/Overlay-Zustand
        // muss zurückgesetzt werden, sonst hängt die Seite mit Spinner + gesperrtem Button.
        window.addEventListener("pageshow", (e) => this.onPageShow(e));
    }

    private onSubmitAnalyse(e: JQuery.SubmitEvent) {
        // Zweiter Submit (Doppelklick / Enter nach Klick) -> verwerfen.
        if (this.submitting) {
            this.log("Submit ignoriert — Analyse läuft bereits");
            e.preventDefault();
            return;
        }
        // Kein Start ohne gültige Auswahl (Weiter-Button gesperrt).
        if ($("#btnDetailNavSave").prop("disabled")) {
            e.preventDefault();
            return;
        }

        this.submitting = true;
        $("#btnDetailNavSave").prop("disabled", true);
        // Zwei Zeilen (Hauptzeile + Erläuterung) — statischer Text, kein User-Input.
        $("#screenblockText").html(
            "Analyse läuft …<br><span class=\"erz-progress-sub\">Das kann bei mehrseitigen Dokumenten bis zu einer Minute dauern.</span>");
        this.lock();
    }

    private onPageShow(e: PageTransitionEvent) {
        if (!e.persisted) {
            return;
        }
        this.log("pageshow aus bfcache — Sperre zurücksetzen");
        this.submitting = false;
        this.unlock();
        this.updateWeiterButton();
    }

    upload() {
        AppLog.logInfo("upload");
        $("#frmUpload").submit();
    }

    clickUnCheck(clickEvent: JQuery.ClickEvent) {
        this.log("clickUnCheck");
        clickEvent.preventDefault();
        $("#cards input:checkbox").removeAttr("checked");
        $("#btnOcrAlleUncheck").addClass("d-none");
        $("#btnOcrAlleCheck").removeClass("d-none");
    }

    clickCheck(clickEvent: JQuery.ClickEvent) {
        this.log("clickCheck");
        clickEvent.preventDefault();
        $("#cards input:checkbox").attr("checked", "checked");
        $("#btnOcrAlleUncheck").removeClass("d-none");
        $("#btnOcrAlleCheck").addClass("d-none");
    }

    updateWeiterButton() {
        const canProceed = $("#chkZugFerd").is(":checked") || $("#chkOcrGewuenscht").is(":checked");
        $("#btnDetailNavSave").prop("disabled", !canProceed);
    }

}
